import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import ContractList from './ContractList';
import ContractListService from '../services/ContractListService';

const ContractListContainer = () => {
  return (
    <ContractList
      contracts={toJS(ContractListService.contracts)}
      pagination={ContractListService.pagination}
      status={ContractListService.status}
      fetching={ContractListService.fetch.fetching}
      onChange={ContractListService.handleChange}
      onAction={ContractListService.handleAction}
    />
  );
};

export default observer(ContractListContainer);
